module.exports = __webpack_public_path__ + "static/media/personlg.0461da7c.svg";